import { Injectable } from '@angular/core';
import { DwModalSize, DwMenuActionType, DwMetaDataFormPreferences, DwMetaDataRoutingService, DwModalResult,
    DwUiConfigRegistryService } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { AppMetaData, ChallengeTeamEntity } from '../../../meta-data/app-meta-data.service';
import { appearanceEditorSection } from '../../shared/components/appearance-editor/appearance-editor.config';

/** Participant forms use CAP's default form page and ORM save lifecycle. */
@Injectable({ providedIn: 'root' })
export class TeamFormService {
    constructor(private routing: DwMetaDataRoutingService, registry: DwUiConfigRegistryService) {
        const details = { sectionType: 'form', formStyle: 'verticleForm', showTitle: false,
            fields: ['TeamName', 'TeamDescription', 'TeamLocation'].map(attrName => ({ attrName, columnItemPreferences: {} })) };
        const membership = { sectionType: 'form', formStyle: 'verticleForm', showTitle: false,
            columnPreferences: { columns: 3, columnLayoutMode: 'grid12', columnDetails: [] },
            fields: ['IsPrivateTeam', 'RequestApprovalToJoin', 'TeamLocked'].map(attrName => ({ attrName, columnItemPreferences: {} })) };
        const createPreferences = Object.assign(new DwMetaDataFormPreferences(), {
            hidePrimaryKey: true,
            section: { sectionType: 'container', showTitle: false, sections: [details, membership] },
        });
        registry.registerConfig('ChallengeTeam-participant-team-create', createPreferences);
        registry.registerConfig('ChallengeTeam-participant-team', Object.assign(new DwMetaDataFormPreferences(), {
            hidePrimaryKey: true,
            section: { sectionType: 'container', showTitle: false, sections: [details, membership] },
        }));
        registry.registerConfig('ChallengeTeam-participant-team-style', Object.assign(new DwMetaDataFormPreferences(), {
            hidePrimaryKey: true,
            section: { sectionType: 'container', showTitle: false, sections: [appearanceEditorSection(true)] },
        }));
    }

    create(challengeId: number): Observable<DwModalResult<ChallengeTeamEntity>> {
        return this.routing.openAddEditViewModal(DwMenuActionType.add, AppMetaData.ChallengeTeam.ItemDetail.itemName,
            null, { ChallengeTeamId: null, ChallengeDefinitionId: challengeId, TeamLocked: false, IsPrivateTeam: false, RequestApprovalToJoin: true },
            null, 'participant-team-create', { title: 'Create a team' }, true);
    }

    edit(teamId: number): Observable<DwModalResult<ChallengeTeamEntity>> {
        return this.routing.openAddEditViewModal(DwMenuActionType.edit, AppMetaData.ChallengeTeam.ItemDetail.itemName,
            teamId, null, null, 'participant-team', { title: 'Edit team' }, true);
    }
    style(teamId: number): Observable<DwModalResult<ChallengeTeamEntity>> {
        return this.routing.openAddEditViewModal(DwMenuActionType.edit, AppMetaData.ChallengeTeam.ItemDetail.itemName,
            teamId, null, null, 'participant-team-style', { title: 'Team style', modalSize: DwModalSize.custom, customModalWidth: 'min(560px, 95vw)', customModalHeight: 'auto' }, true);
    }
}
